module.exports = "<span class=\"loader\" [ngStyle]=\"{'color': loaderColor}\"></span>\n"